<template>
    <div>
      <modal name="importacion" :width="500" :height="'auto'" :clickToClose="false">
        <div class="modal-content">
          <!-- <span class="closebtn" @click="closeError">&times;</span> -->
          <h4 style="color: white;">Generación de operación de pago</h4>
        </div>
        <div class="text-center p-5 mb-3">
            <h5>Se genero tu número de proceso de Importación:</h5>
            <div class="input-group input-group-form-control mb-2">
                <input ref="copyInput" type="text" class="form-control text-center input-group-form-control" :value="numImportacion" aria-label="readonly input example" readonly>
                <button type="button" @click="copyToClipboard" class="btn btn-outline-secondary "><i class="far fa-copy"></i></button>
            </div>
            <span v-if="copy"><i class="fas fa-check mr-1"></i> ¡Número copiado exitosamente! </span>
            <p class="mt-3">Te notificaremos en cuanto se realice el pago. ¡Gracias!</p>
            <button class="btn btn-blue col-4" @click="closeModal">Cerrar</button>
        </div>
      </modal>
    </div>
  </template>
  
  <script>
  export default {
    name: 'App',
    props: {
        numImportacion: String
    },
    data() {
      return {
        // numImportacion: 'IMP654646854652029',
        copy: false
      };
    },
    methods: {
      closeModal() {

        // this.$modal.hide('importacion');
        this.$router.go(0);
      },
      copyToClipboard() {
        const input = this.$refs.copyInput;
      input.select();
      input.setSelectionRange(0, 99999); // Para dispositivos móviles
      navigator.clipboard.writeText(input.value).then(() => {
        this.copy = true
        setTimeout( () => {
            this.copy = false
        }, 1500)
      }).catch(err => {
        console.error('Error al copiar el texto: ', err);
      });
    }
    }
  };
  </script>
  
  <style >
  .btn-blue{
    border-radius: 10px;
    background-image: linear-gradient(to right, #085da8, #003c71); /* Color de fondo verde */
    border: #003c71;
    color: white;
}
  span{
    color: #00711caf;
  }
  .input-group {
  max-width: 500px;
  margin: 0 auto;
}

.input-group-form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 1.2rem; /* Aumenta el tamaño de la letra */
  color: rgb(19, 55, 173);
  font-weight: 700;
}

.input-group .btn-outline-secondary {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
   .vm--modal {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    background-color: white;
    border-radius: 30px !important;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
}
  .modal-content {
    padding: 15px;
    background-color: #003c71; /* Red */
    color: white;
    border-top-left-radius: 15px; /* Rounded top-left corner */
    border-top-right-radius: 15px; /* Rounded top-right corner */
    position: relative; /* For positioning the close button */
    text-align: center; /* Center the text */
  }
  
  .closebtn {
    position: absolute;
    top: 10px;
    right: 15px;
    color: white;
    font-weight: bold;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .closebtn:hover {
    color: rgb(214, 212, 212);
  }
  </style>
  